// extracted by mini-css-extract-plugin
export default {"center":"ui_center__M-Pmv","center-header":"ui_center-header__jD4LO","center-title":"ui_center-title__6mDea","center-subtitle":"ui_center-subtitle__rIbTJ"};